import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface RoadTypesParams extends DefaultHttpHeaders {}

@Injectable()
export class RoadTypesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining Q&B road types
   * Service for obtaining Q&B road types
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundRoadTypes
   */
  roadTypes(params: RoadTypesParams): Observable<ParameterResult[]> {
    return this.get<ParameterResult[]>({
      suffix: '/comeround/catalog/roadTypes',
    });
  }
}
